import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const token = localStorage.getItem('token');

    if (token) {
      // El usuario tiene un token válido
      return true;
    } else {
      // El usuario no tiene un token válido, redirigir al formulario de inicio de sesión
      this.router.navigate(['/general/login']);
      return false;
    }
  }
  
}
